// extracted by mini-css-extract-plugin
export default {"toggle":"ToggleButton_toggle__mo9B5","leftAlign":"ToggleButton_leftAlign__4ZuqG","rightAlign":"ToggleButton_rightAlign__4JJBr"};